/**
 * Lifts the rating, title and subtitle above the gallery on phones.
 *
 * Two things this got wrong before, both worth keeping in mind:
 *
 * 1. The group must be prepended INTO the media wrapper, not inserted before
 *    it. product-component is a two-column subgrid; a third child there gets
 *    auto-placed into a 40px column and every line wraps to one character.
 *
 * 2. Two .group-block elements contain the h1 — the title's own wrapper and
 *    the outer one holding the entire buy box. Selecting the first match moved
 *    the tiers and the add-to-cart button above the gallery too, so resolve it
 *    upwards from the h1 and refuse anything that looks like the buy box.
 *
 * On mobile the media wrapper spans the page's margin columns so images can go
 * edge to edge, which means this group has to supply its own side padding.
 */
(() => {
  const QUERY = window.matchMedia('(max-width: 749px)');
  const BUY_BOX = '.bundle-selector, .add-to-cart-button, .buy-buttons-block';

  const grid = document.querySelector('[data-product-grid-content]');
  const media = grid?.querySelector('.product-information__media');
  const details = grid?.querySelector('[class*="product-details"]');
  if (!grid || !media || !details) return;

  const rating = details.querySelector('.ms-rating-row');
  const h1 = details.querySelector('h1');
  const titleGroup = h1?.closest('.group-block');
  if (!rating || !titleGroup) return;

  const subtitle = titleGroup.nextElementSibling;
  const nodes = [titleGroup, subtitle, rating].filter(Boolean);

  // Hard stop: nothing that carries a price or a buy button gets moved.
  if (nodes.some((node) => node.querySelector?.(BUY_BOX))) {
    console.warn('[ms-mobile-lead] Selection reached the buy box; leaving the layout alone.');
    return;
  }

  const home = nodes.map((node) => ({ node, parent: node.parentNode, next: node.nextSibling }));

  const lead = document.createElement('div');
  lead.className = 'ms-mobile-lead';

  const apply = () => {
    if (QUERY.matches) {
      if (lead.isConnected) return;
      nodes.forEach((node) => lead.append(node));
      media.prepend(lead);
    } else {
      if (!lead.isConnected) return;
      home.forEach(({ node, parent, next }) => parent.insertBefore(node, next));
      lead.remove();
    }
  };

  apply();
  QUERY.addEventListener('change', apply);
})();
